<template>
  <Card>
    <template #title>Print Test</template>
    <template #subtitle>Pastikan Printer Sudah Terkoneksi.</template>
    <template #content>
      <div class="grid grid-cols-2 gap-2">
        <Button
          icon="pi pi-print"
          aria-label="Print"
          @click="printDocument('bill')"
          label="Print Bill"
        />
        <Button
          icon="pi pi-print"
          aria-label="Print"
          @click="printDocument('checker')"
          label="Print Checker"
        />
        <Button
          icon="pi pi-print"
          aria-label="Print"
          @click="printDocument('receipt')"
          label="Print Receipt"
        />
      </div>
    </template>
  </Card>

  <!-- Print sections with print-specific styles -->
  <div class="print-section" id="receipt" :class="{ hidden: true }">
    <ReceiptPrintNoJSP
      store-name="Erista Dwatiga"
      store-address="jalan Semarang"
      store-phone="085104116711"
      :subtotal="10000"
    />
  </div>
  <div class="print-section" id="bill" :class="{ hidden: true }">
    <BillPrint
      store-name="Erista Dwatiga"
      store-address="jalan Semarang"
      store-phone="085104116711"
      :subtotal="10000"
    />
  </div>
  <div class="print-section" id="checker" :class="{ hidden: true }">
    <CheckerPrint />
  </div>
</template>

<script>
import axios from "axios";
import { defineComponent, ref } from "vue";
import ReceiptPrintNoJSP from "@/components/print/receipt/ReceiptPrintNoJSP.vue";
import { Button, Card } from "primevue";
import BillPrint from "@/components/print/receipt/BillPrint.vue";
import CheckerPrint from "@/components/print/checker/CheckerPrint.vue";

export default defineComponent({
  name: "PrintTes",
  components: {
    Button,
    Card,
    ReceiptPrintNoJSP,
    BillPrint,
    CheckerPrint,
  },
  setup() {
    const checkerText = ref(`
#171224016 (12:39:10 AM)
Tipe Transaksi : Dine-In
Lokasi : VIP LT-1
Waiter : Default
Sender : NANDA SERVER
BAR
1
MINERAL WATER
2
FREE GREEN TEA
2
KRATINGDAENG`);

    const receiptText = ref(`\x1b\x61\x01
================================
${process.env.VUE_APP_STORE_NAME}
${process.env.VUE_APP_STORE_ADDRESS}
${process.env.VUE_APP_STORE_PHONE}
================================\x1b\x61\x00

No. Invoice   : MAKLO10
Tanggal      : 29 Jan 2025, 00.39
Nama Tamu    : Erista
Kasir        : Erista Dwatiga
Marketing    : Erista Dwatiga
================================

Sate
Disc: Rp 100    
1 x Rp 10.000
Rp 9.900

Nasi Goreng
1 x Rp 10.000
Rp 10.000
================================

Subtotal       : Rp 10.000
Tax            : Rp 1.000
Service Charge : Rp 1.000
Total Diskon   : Rp 1.000

================================\x1b\x61\x01

TERIMA KASIH ATAS
KUNJUNGAN ANDA

SIMPAN STRUK INI SEBAGAI
BUKTI PEMBAYARAN

================================\x1b\x61\x00`);

    const billText = ref(`\x1b\x61\x01
================================
${process.env.VUE_APP_STORE_NAME}
${process.env.VUE_APP_STORE_ADDRESS}
${process.env.VUE_APP_STORE_PHONE}
================================\x1b\x61\x00

No. Invoice   : MAKLO10
Tanggal      : 29 Jan 2025, 00.41
Nama Tamu    : Erista
Kasir        : Erista Dwatiga
Marketing    : Erista Dwatiga
================================

Sate
Disc: Rp 100
1 x Rp 10.000
Rp 9.900

Nasi Goreng
1 x Rp 10.000
Rp 10.000
================================

Subtotal       : Rp 10.000
Tax            : Rp 1.000
Service Charge : Rp 1.000
Total Diskon   : Rp 1.000
--------------------------------
Total Bill    : Rp 20.000
Tunai         : Rp 30.000
Kembalian     : Rp 10.000
================================\x1b\x61\x01

TERIMA KASIH ATAS
KUNJUNGAN ANDA

SIMPAN STRUK INI SEBAGAI
BUKTI PEMBAYARAN

================================\x1b\x61\x00`);

    const printDocument = async (type) => {
      let text;
      switch (type) {
        case "checker":
          text = checkerText.value;
          break;
        case "bill":
          text = billText.value;
          break;
        case "receipt":
          text = receiptText.value;
          break;
      }
      try {
        const print_url =
          process.env.VUE_APP_ROOT_API + "/printer/printing/custom-print";
        const response = await axios.post(print_url, {
          text: text,
          printer_ip: process.env.VUE_APP_CASIER_IP,
        });
        console.log(response);
      } catch (error) {
        console.log(error);
      }
    };

    return {
      printDocument,
    };
  },
});
</script>

<style>
/* Print-specific styles */
@media print {
  body * {
    visibility: hidden;
  }
  .print-section,
  .print-section * {
    visibility: visible;
  }
  .print-section {
    position: absolute;
    left: 0;
    top: 0;
  }
  @page {
    margin: 0;
    size: 80mm 297mm; /* For thermal receipt printer - adjust size as needed */
  }
}

.hidden {
  display: none;
}

/* Regular screen styles */
.print-section {
  display: none;
}
</style>
